import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b21250fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question-detail" }
const _hoisted_2 = { style: {"width":"30px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick", "src"]
const _hoisted_5 = { key: 1 }

import { isArray } from 'lodash';
import { withDefaults } from 'vue';
import { BaseDescriptions, BaseDescriptionsItem } from 'xrk-components';


export default /*#__PURE__*/_defineComponent({
  __name: 'question-detail-17',
  props: {
    questionInfo: { default: () => ({}) }
  },
  emits: ['changeImgUrl'],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;
const onChangeShowIndex = url => {
  emits('changeImgUrl', url);
};
const getTitle = (topic, index) => {
  return `${index + 1}.${topic.label}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionInfo, (topic, index) => {
      return (_openBlock(), _createBlock(_unref(BaseDescriptions), {
        key: index,
        title: getTitle(topic, index),
        column: 1,
        size: "large",
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          (topic.remark)
            ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                key: 0,
                label: `备注：${topic.remark}`
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (index === 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(topic.values, (value, index) => {
                return (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                  key: index,
                  style: {"display":"flex","align-items":"center"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(value.label) + "：", 1),
                    _createElementVNode("span", null, _toDisplayString(value.values), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            : (_unref(isArray)(topic.values))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(topic.values, (value, index) => {
                  return (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), {
                    key: index,
                    style: {"display":"flex","align-items":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(value.informationName || '无'), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              : ([20].includes(topic.topicType))
                ? (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 3 }, {
                    default: _withCtx(() => [
                      (topic.values)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("img", {
                              onClick: ($event: any) => (onChangeShowIndex(topic.values)),
                              src: topic.values
                            }, null, 8, _hoisted_4)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, "无"))
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_unref(BaseDescriptionsItem), { key: 4 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(topic.values || '无'), 1)
                    ]),
                    _: 2
                  }, 1024))
        ]),
        _: 2
      }, 1032, ["title"]))
    }), 128))
  ]))
}
}

})